import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';


// TS type
import { RootState } from '@redux/store';

// API
import { fetchProductItemDesc } from '@libs/apiCall';

// redux actions
import { setProductDescKey } from '@redux/Common/actions';

interface InformationsProps {
    formatId?: string;
}
interface DescItem {
    Title: string;
    Content: string;
}

const Informations: React.FC<InformationsProps> = ({ formatId }) => {
    const dispatch = useDispatch();
    const { ETID, ProductDescKey } = useSelector((state: RootState) => state.Common);
    const [descList, setDescList] = useState<DescItem[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetchProductItemDesc(ETID, formatId, ProductDescKey);
            const data = await response.json();
            const allDescList = data.FormatIDList.reduce((acc: any[], format: any) => {
                return acc.concat(format.DescList);
            }, []);
            setDescList(allDescList);
            const apiProductDescKey = data.Key;
            dispatch(setProductDescKey(apiProductDescKey));
        };

        fetchData();
    }, [ETID, formatId]);

    return (
        <>
            {descList.length > 0 && (
                <div className="informations">
                    {descList.map((descItem, index) => (
                        <div className="info" key={index}>
                            <div className="infoTitle">{descItem.Title}</div>
                            <div
                                className="infoContent"
                                dangerouslySetInnerHTML={{ __html: descItem.Content }}
                            ></div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default Informations;
